export default __webpack_public_path__ + "static/media/user-dashboard.78892c98.svg";